


























import CommonBase from "../CommonBase";
import {Component, Prop} from "vue-property-decorator";
import InfoBtn from "../shared/InfoBtn.vue";
import InfoDialog from "../InfoDialog.vue";
import rd from "../../modules/vRoutedefs";

@Component({
    components: {
        "at-info-btn": InfoBtn,
        "at-info-dialog": InfoDialog,
    }
})
export default class RegreminderInfoDialog extends CommonBase {
    @Prop({default: false})
    unavailable!: boolean;

    value: boolean = false;

    get opened() {
        return this.value;
    }
    set opened(v: boolean) {
        this.value = v;
        //this.$emit("input", v);
    }

    readonly regreminderDocsTo = {path: rd.docs.regreminder.path};
}
